const index = () => import('./Index');

//2022年绿色制造工程补助资金申请表
export default {
  routes: [
    {
      path: '/green/v2022/index',
      name: 'green_v2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/green/v2022/router.js